/* tslint:disable */
import {
  GameEmoji,
  PlayerSurvey
} from '../index';

declare var Object: any;
export interface SurveyInterface {
  "image": string;
  "choices": Array<any>;
  "comments": Array<any>;
  "averageRating"?: number;
  "playerCount"?: number;
  "displayType": string;
  "question": string;
  "id"?: any;
  "gameEmojiId"?: any;
  "createdAt": Date;
  "updatedAt": Date;
  gameEmoji?: GameEmoji;
  playerSurveys?: PlayerSurvey[];
}

export class Survey implements SurveyInterface {
  "image": string;
  "choices": Array<any>;
  "comments": Array<any>;
  "averageRating": number;
  "playerCount": number;
  "displayType": string;
  "question": string;
  "id": any;
  "gameEmojiId": any;
  "createdAt": Date;
  "updatedAt": Date;
  gameEmoji: GameEmoji;
  playerSurveys: PlayerSurvey[];
  constructor(data?: SurveyInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Survey`.
   */
  public static getModelName() {
    return "Survey";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Survey for dynamic purposes.
  **/
  public static factory(data: SurveyInterface): Survey{
    return new Survey(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Survey',
      plural: 'suerveys',
      path: 'suerveys',
      idName: 'id',
      properties: {
        "image": {
          name: 'image',
          type: 'string'
        },
        "choices": {
          name: 'choices',
          type: 'Array&lt;any&gt;'
        },
        "comments": {
          name: 'comments',
          type: 'Array&lt;any&gt;'
        },
        "averageRating": {
          name: 'averageRating',
          type: 'number',
          default: 0
        },
        "playerCount": {
          name: 'playerCount',
          type: 'number',
          default: 0
        },
        "displayType": {
          name: 'displayType',
          type: 'string'
        },
        "question": {
          name: 'question',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
        "gameEmojiId": {
          name: 'gameEmojiId',
          type: 'any'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        gameEmoji: {
          name: 'gameEmoji',
          type: 'GameEmoji',
          model: 'GameEmoji',
          relationType: 'belongsTo',
                  keyFrom: 'gameEmojiId',
          keyTo: 'id'
        },
        playerSurveys: {
          name: 'playerSurveys',
          type: 'PlayerSurvey[]',
          model: 'PlayerSurvey',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'surveyId'
        },
      }
    }
  }
}
